import * as React from 'react'
import styled, { css } from 'styled-components'
import { IconName, ThemeName } from '../../../lib/constants'
import { Icon } from '../Icon/Icon'
import { getThemeColor } from '../../../lib/utils'

export interface CardProps {
  children: React.ReactNode
  as?: React.ElementType
  $theme?: ThemeName
  cardIcon?: IconName
  noBorder?: boolean
  [key: string]: any
}

export const Wrapper = styled.div<{
  isLink?: boolean
  noBorder?: boolean
  $theme?: ThemeName
}>`
  border-radius: 1rem;
  border: 1px solid ${({ theme, $theme }) => getThemeColor(theme, $theme, 1)};
  display: block;
  position: relative;

  @media screen and (max-width: 768px) {
    padding: 0;
  }

    ${({ $theme }) =>
    $theme &&
    css`
      background-color: ${({ theme }) => getThemeColor(theme, $theme, 7)};
    `}


  ${({ isLink }) =>
    isLink &&
    css`
      color: inherit;
      text-decoration: none;
      transition: outline 0.1s, background-color 0.3s;
      outline: 0 solid #000;

      &:hover {
        // background-color: var(--c-theme-6);
        // outline: 1px solid #000;
      }
    `}

  ${({ noBorder }) =>
    noBorder &&
    css`
      border: none;
      outline: none;

    `}  
`

const IconWrapper = styled.div`
  position: absolute;
  top: 1rem;
  right: 1.5rem;
`

export const Card = ({ as, cardIcon, children, $theme, noBorder, ...rest }: CardProps) => {
  const isLink = !!rest.href || !!rest.to
  return (
    <Wrapper as={as} $theme={$theme} isLink={isLink} noBorder={noBorder} {...rest}>
      {cardIcon && (
        <IconWrapper>
          <Icon name={cardIcon} iconSize="0.9rem" />
        </IconWrapper>
      )}
      {children}
    </Wrapper>
  )
}
